import { createReducer, on } from '@ngrx/store';
import { Order } from '../../core/models';
import { AuthActions } from '../auth/auth.actions';
import { OrdersActions } from './orders.actions';

export interface OrdersState {
  orders: Order[];
  loading: boolean;
  loaded: boolean;
  placing: boolean;
  lastOrderId: string | null;
  error: string | null;
}

export const initialOrdersState: OrdersState = {
  orders: [],
  loading: false,
  loaded: false,
  placing: false,
  lastOrderId: null,
  error: null,
};

export const ordersReducer = createReducer(
  initialOrdersState,

  on(OrdersActions.loadOrders, (state) => ({ ...state, loading: true, error: null })),
  on(OrdersActions.loadOrdersSuccess, (state, { orders }) => ({
    ...state,
    orders,
    loading: false,
    loaded: true,
  })),
  on(OrdersActions.loadOrdersFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(OrdersActions.placeOrder, (state) => ({ ...state, placing: true, error: null })),
  on(OrdersActions.placeOrderSuccess, (state, { order }) => ({
    ...state,
    placing: false,
    orders: [order, ...state.orders],
    lastOrderId: order.id,
  })),
  on(OrdersActions.placeOrderFailure, (state, { error }) => ({
    ...state,
    placing: false,
    error,
  })),

  on(AuthActions.logout, () => initialOrdersState),
);
